/**
 * Emergency cache clear utility
 * Exposes window.clearAllSwirlCache() to force-clear everything
 */

export function clearAllSwirlCache() {
  console.log('🧹 Clearing ALL Swirl caches...');
  
  // Get all localStorage keys
  const keys = Object.keys(localStorage);
  let clearedCount = 0;
  
  // Clear all Swirl-related keys
  keys.forEach(key => {
    if (
      key.includes('swirl_') ||
      key.includes('smart_insights') ||
      key.includes('memory_surfacing') ||
      key.includes('weekly_summary') ||
      key.includes('dashboard_') ||
      key.includes('vault_') ||
      key.includes('dismissed_') ||
      key.includes('snoozed_')
    ) {
      localStorage.removeItem(key);
      clearedCount++;
      console.log(`  ❌ Cleared: ${key}`);
    }
  });
  
  console.log(`✅ Cleared ${clearedCount} cache entries`);
  console.log('🔄 Reload the page to see fresh data');
  
  return clearedCount;
}

// Expose globally
if (typeof window !== 'undefined') {
  window.clearAllSwirlCache = clearAllSwirlCache;
  console.log('🧹 Cache clear available: window.clearAllSwirlCache()');
}





